import React, { useState } from 'react';
import { track, EVENTS } from '../lib/analytics';

const TelegramButton = ({ groupLink = "https://t.me/+ffu03urpqN9iZTI9" }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed z-50 flex flex-col items-start gap-1.5 left-3 sm:left-6 bottom-[max(0.75rem,env(safe-area-inset-bottom))] sm:bottom-6">
      {/* Close button */}
      <button
        onClick={() => setIsVisible(false)}
        data-testid="telegram-close-btn"
        className="group/close p-1.5 -m-1.5 rounded-full"
        title="Fechar"
        aria-label="Fechar botão flutuante"
      >
        <span className="w-6 h-6 rounded-full bg-gray-800/90 border border-white/20 flex items-center justify-center group-hover/close:bg-gray-700 transition-colors">
          <svg className="w-3 h-3 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      </button>

      {/* Telegram button */}
      <a
        href={groupLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="telegram-floating-btn"
        className="relative group"
        onClick={() => track(EVENTS.TELEGRAM_CLICK, { source_step: 'floating_button' })}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        aria-label="Telegram"
      >
        {/* Pulse animation ring */}
        <div className="absolute inset-0 rounded-full bg-sky-500/30 animate-ping motion-reduce:hidden" style={{ animationIterationCount: 4 }} />

        {/* Glow effect */}
        <div
          className="absolute -inset-2 rounded-full transition-all duration-300"
          style={{
            background: 'radial-gradient(circle, rgba(34, 158, 217, 0.4) 0%, transparent 70%)',
            filter: 'blur(8px)',
            opacity: isHovered ? 1 : 0.6
          }}
        />

        {/* Main button */}
        <div
          className={`relative w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center transition-all duration-300 ${
            isHovered ? 'scale-110 shadow-2xl' : 'scale-100'
          }`}
          style={{
            background: 'linear-gradient(135deg, #2AABEE 0%, #229ED9 100%)',
            boxShadow: isHovered
              ? '0 8px 32px rgba(34, 158, 217, 0.5), 0 0 0 4px rgba(34, 158, 217, 0.2)'
              : '0 4px 20px rgba(34, 158, 217, 0.4)'
          }}
        >
          {/* Telegram Icon */}
          <svg
            className="w-6 h-6 sm:w-8 sm:h-8 text-white"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.464.141a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
          </svg>
        </div>
      </a>
    </div>
  );
};

export default TelegramButton;
